<template>
    <section class="page-main grow flex gap-2 p-5 pt-10 h-screen overflow-auto">
        <ColorColumn
            v-for="index in numberOfHues"
            :key="index"
            :column-index="index - 1"
        />
    </section>
</template>

<script>
import ColorColumn from './ColorColumn.vue';
import { store } from '../store.js'
import { computed } from 'vue'

export default {
    name: 'PageMain',
    components: {
        ColorColumn
    },
    setup() {
        const numberOfHues = computed(() => store.numberOfHues)

        return {
            numberOfHues
        }
    }
}
</script>